import { Radio } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { UserStore } from '@/global-states'
import { showDeclare } from '@/libs/util'

const SystemDeclare: FC = () => {
  const { t: translate } = useTranslation(['declare'])
  const { declareChecked } = UserStore

  return (
    <div className="declare">
      <Radio checked={declareChecked} onClick={() => (UserStore.declareChecked = !UserStore.declareChecked)}></Radio>
      {translate('declare.agreement_text')}
      <label className="link" onClick={showDeclare}>
        {translate('declare.user_agreement')}
      </label>
    </div>
  )
}

export default SystemDeclare
